export const enum VideoSettings {
  AUTOPLAY = 'Autoplay',
  MUTED = 'Muted',
  LOOP = 'Loop'
}

export type VideoSettingsOption = `${VideoSettings}`;
